import { Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { RANGE_OPTIONS } from '@/features/admin/processing-format'

export function ProcessingRangeToggle({
  rangeKey,
  refreshMs,
  onSelect,
}: {
  rangeKey: string
  refreshMs: number
  onSelect: (key: string) => void
}) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-3">
      <div className="inline-flex rounded-md border bg-muted/30 p-0.5">
        {RANGE_OPTIONS.map(opt => (
          <button
            key={opt.key}
            type="button"
            onClick={() => onSelect(opt.key)}
            className={`rounded px-3 py-2 text-xs font-medium transition-colors md:px-2.5 md:py-1 ${
              rangeKey === opt.key
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {opt.key === 'all' ? t('admin.processing.range.all') : opt.label}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
        <Loader2 className="h-3 w-3 animate-spin" />
        {refreshMs / 1000}s
      </div>
    </div>
  )
}
